import { render, staticRenderFns } from "./OrgListNodeItem.vue?vue&type=template&id=66f60110&scoped=true&"
import script from "./OrgListNodeItem.vue?vue&type=script&lang=js&"
export * from "./OrgListNodeItem.vue?vue&type=script&lang=js&"
import style0 from "./OrgListNodeItem.vue?vue&type=style&index=0&id=66f60110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f60110",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpandTransition,VIcon})
